<template>
  <span :class="$style.counter">
    <span
      :class="[
        $style.counter__usage,
        { [$style['counter__usage--reachLimit']]: hasReachedUpperLimit },
      ]"
      >{{ usage }}</span
    >
    <template v-if="upperLimit">
      <span :class="$style.counter__delimiter">/</span>
      <span :class="$style.counter__upperLimit">
        {{ upperLimit }}
      </span>
    </template>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{ usage: number; upperLimit?: number }>()

const hasReachedUpperLimit = computed(() => {
  const { usage, upperLimit } = props
  return upperLimit && usage >= upperLimit
})
</script>

<style lang="scss" module>
$height: 24px;

.counter {
  display: flex;
  height: $height;
  align-items: flex-end;
  line-height: 1;

  &__usage {
    color: $color-text-and-object-accent-primary;
    font-size: $height;
    font-weight: bold;

    &--reachLimit {
      color: $color-caution-accent;
    }
  }

  &__delimiter {
    padding-bottom: 4px;
    margin: 0 4px;
    font-size: 14px;
    font-weight: bold;
  }

  &__upperLimit {
    padding-bottom: 1px;
    font-size: 18px;
    font-weight: bold;
  }
}
</style>
